import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { TranslationProvider } from './hooks/useTranslations';
import { HomePage } from './pages/HomePage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsConditionsPage } from './pages/TermsConditionsPage';
import { RefundPolicyPage } from './pages/RefundPolicyPage';
function App() {
  return <TranslationProvider data-id="element-0">
      <Router data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-6" />} data-id="element-5" />
          <Route path="/terms-conditions" element={<TermsConditionsPage data-id="element-8" />} data-id="element-7" />
          <Route path="/refund-policy" element={<RefundPolicyPage data-id="element-10" />} data-id="element-9" />
        </Routes>
      </Router>
    </TranslationProvider>;
}
export { App };